import React from 'react';
import { CONNECTED_ACCOUNT_FALLBACK_LIMIT } from '@/utils/constants';
import { GLEAP_CONNECTED_ACCOUNT_LIMIT_FORM_KEY } from '@/utils/ts/gleap';
import Gleap from 'gleap';
import { useSelector } from 'react-redux';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';
import AddCircleOutline from '@/components/Icons/icons/AddCircleOutline';

interface Props {
  brandsCount: number;
  handleShowAddNewAccount: () => void;
}

const Header: React.FC<Props> = ({ brandsCount, handleShowAddNewAccount }) => {
  const { userDetails } = useSelector((state: any) => state.user);

  const limit = userDetails?.featureLimit?.connectedAccountLimit ?? CONNECTED_ACCOUNT_FALLBACK_LIMIT;

  const brandsAdded = brandsCount - 1;

  const limitReached = brandsAdded >= limit;

  if (brandsCount === 1) {
    return (
      <div className="w-full border-b-default p-6 text-xl font-medium text-default text-center">Choose an Account</div>
    );
  } else {
    return (
      <div
        className={`w-full flex flex-between items-center border-b-default p-6 ${brandsCount > 4 ? 'shadow-down' : ''}`}>
        <span className="text-xl font-medium text-default">Choose an Account</span>
        <CustomTooltip
          show={limitReached}
          title={
            <>
              {brandsAdded} account{brandsAdded === 1 ? '' : 's'} added.{' '}
              <span
                className="underline cursor-pointer"
                onClick={() => {
                  Gleap.setTicketAttribute('Intent', 'I want to link more accounts to my profile');
                  Gleap.startClassicForm(GLEAP_CONNECTED_ACCOUNT_LIMIT_FORM_KEY, false);
                }}>
                Contact Support
              </span>{' '}
              for more
            </>
          }>
          <ButtonComponent
            icon={<AddCircleOutline color="var(--icon-highlight)" />}
            variant="primary-text"
            onClick={handleShowAddNewAccount}
            className="p-0"
            disabled={limitReached}>
            Add New
          </ButtonComponent>
        </CustomTooltip>
      </div>
    );
  }
};

export default Header;
